import { forwardRef } from 'react'
import { ChevronDown } from 'lucide-react'
import { cn } from '@/lib/utils'

export const Select = forwardRef(function Select(
  { className, label, error, hint, required, options = [], placeholder, id, ...props },
  ref,
) {
  const inputId = id || props.name
  return (
    <div className={cn('w-full', className)}>
      {label && (
        <label
          htmlFor={inputId}
          className="mb-1.5 block text-sm font-semibold text-ink-800"
        >
          {label}
          {required && <span className="ml-0.5 text-accent-600">*</span>}
        </label>
      )}
      <div className="relative">
        <select
          id={inputId}
          ref={ref}
          className={cn(
            'block w-full appearance-none rounded-xl bg-white pl-3.5 pr-10 text-sm text-ink-900',
            'ring-1 ring-inset transition-all duration-150',
            'focus:outline-none focus:ring-2 focus:ring-primary-500',
            error
              ? 'ring-rose-400 focus:ring-rose-500'
              : 'ring-ink-200 hover:ring-ink-300',
            'h-11',
          )}
          {...props}
        >
          {placeholder && <option value="">{placeholder}</option>}
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        <ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-400" />
      </div>
      {error ? (
        <p className="mt-1.5 text-xs font-medium text-rose-600">{error}</p>
      ) : hint ? (
        <p className="mt-1.5 text-xs text-ink-500">{hint}</p>
      ) : null}
    </div>
  )
})
